import React from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import Breadcrumbs from '../../components/ui/Breadcrumbs';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <Breadcrumbs />
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-foreground mb-4">Terms of Service</h1>
            <p className="text-muted-foreground">
              Last updated: October 10, 2024
            </p>
          </div>

          <div className="prose prose-lg max-w-none">
            <div className="bg-card rounded-lg p-8 shadow-sm mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">Agreement to Terms</h2>
              <p className="text-muted-foreground leading-relaxed">
                By accessing and using HireBroker's services, you accept and agree to be bound by the terms
                and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
              </p>
            </div>

            <div className="space-y-8">
              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">Use License</h2>
                <p className="text-muted-foreground mb-4">
                  Permission is granted to temporarily access the materials (information or software) on HireBroker's website
                  for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title,
                  and under this license you may not:
                </p>
                <ul className="list-disc pl-6 text-muted-foreground">
                  <li>Modify or copy the materials</li>
                  <li>Use the materials for any commercial purpose or for any public display</li>
                  <li>Attempt to decompile or reverse engineer any software contained on our website</li>
                  <li>Remove any copyright or other proprietary notations from the materials</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">User Responsibilities</h2>

                <h3 className="text-lg font-semibold text-foreground mb-2">Account Registration</h3>
                <p className="text-muted-foreground mb-4">
                  When you create an account with us, you must provide information that is accurate, complete, and current
                  at all times. You are responsible for safeguarding the password and for all activities that occur under your account.
                </p>

                <h3 className="text-lg font-semibold text-foreground mb-2">Acceptable Use</h3>
                <p className="text-muted-foreground mb-4">You agree not to use our services to:</p>
                <ul className="list-disc pl-6 text-muted-foreground">
                  <li>Violate any applicable laws or regulations</li>
                  <li>Infringe on the rights of others</li>
                  <li>Transmit harmful or malicious code</li>
                  <li>Attempt to gain unauthorized access to our systems</li>
                  <li>Post false, misleading, or defamatory content</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">Property Listings</h2>

                <h3 className="text-lg font-semibold text-foreground mb-2">Listing Accuracy</h3>
                <p className="text-muted-foreground mb-4">
                  Property owners and agents are responsible for ensuring that all property information, descriptions,
                  and images are accurate and up-to-date. HireBroker is not responsible for the accuracy of property listings.
                </p>

                <h3 className="text-lg font-semibold text-foreground mb-2">Listing Fees</h3>
                <p className="text-muted-foreground">
                  Some services may require payment. All fees are clearly disclosed before any transaction occurs.
                  Refunds are provided according to our refund policy.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">Privacy and Data Protection</h2>
                <p className="text-muted-foreground">
                  Your privacy is important to us. Please review our Privacy Policy, which also governs your use of our services,
                  to understand our practices regarding the collection and use of your personal information.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">Disclaimer</h2>
                <p className="text-muted-foreground mb-4">
                  The materials on HireBroker's website are provided on an 'as is' basis. HireBroker makes no warranties,
                  expressed or implied, and hereby disclaims and negates all other warranties including without limitation,
                  implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property.
                </p>
                <p className="text-muted-foreground">
                  Further, HireBroker does not warrant or make any representations concerning the accuracy, likely results,
                  or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">Limitations</h2>
                <p className="text-muted-foreground">
                  In no event shall HireBroker or its suppliers be liable for any damages (including, without limitation,
                  damages for loss of data or profit, or due to business interruption) arising out of the use or inability
                  to use the materials on HireBroker's website, even if HireBroker or a HireBroker authorized representative
                  has been notified orally or in writing of the possibility of such damage.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">Accuracy of Materials</h2>
                <p className="text-muted-foreground">
                  The materials appearing on HireBroker's website could include technical, typographical, or photographic errors.
                  HireBroker does not warrant that any of the materials on its website are accurate, complete, or current.
                  HireBroker may make changes to the materials contained on its website at any time without notice.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">Links</h2>
                <p className="text-muted-foreground">
                  HireBroker has not reviewed all of the sites linked to its website and is not responsible for the contents
                  of any such linked site. The inclusion of any link does not imply endorsement by HireBroker of the site.
                  Use of any such linked website is at the user's own risk.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">Modifications</h2>
                <p className="text-muted-foreground">
                  HireBroker may revise these terms of service for its website at any time without notice. By using this website,
                  you are agreeing to be bound by the then current version of these terms of service.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">Governing Law</h2>
                <p className="text-muted-foreground">
                  These terms and conditions are governed by and construed in accordance with the laws of Uganda
                  and you irrevocably submit to the exclusive jurisdiction of the courts in that state or location.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-foreground mb-4">Contact Information</h2>
                <p className="text-muted-foreground mb-4">
                  If you have any questions about these Terms of Service, please contact us:
                </p>
                <div className="bg-muted rounded-lg p-4">
                  <p className="text-foreground"><strong>Email:</strong> legal@hirebroker.co</p>
                  <p className="text-foreground"><strong>Phone:</strong> +256 774 509 859</p>
                  <p className="text-foreground"><strong>Address:</strong> Kampala, Uganda</p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;